var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrollDown = function SvgScrollDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 43 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h29.5a13.5 13.5 0 1 1 0 27H0z",
    opacity: 0.475
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002855",
    d: "M28.05 7.432a1.617 1.617 0 0 0-2.268.206l-6.817 8.18-6.817-8.179a1.61 1.61 0 1 0-2.473 2.063l8.052 9.664a1.61 1.61 0 0 0 2.474 0l8.052-9.664a1.61 1.61 0 0 0-.204-2.27"
  })));
};
export default SvgScrollDown;